import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';
import { images } from '../mock';

const Hero = () => {
  return (
    <section id="top" className="relative pt-[110px] md:pt-[130px] pb-16 md:pb-24 bg-[#f8f4ec]">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-7 fade-up">
            <div className="eyebrow label-caps mb-8">Management &amp; Operations · Tauranga</div>
            <h1 className="font-serif text-[#201d1a] text-[46px] sm:text-[62px] md:text-[78px] leading-[1.02] tracking-tight">
              A steady pair of
              <br />
              <span className="italic text-[#a4514a]">hands</span> for your business.
            </h1>
            <p className="mt-8 text-[17px] leading-[1.7] text-[#4a423b] max-w-[560px]">
              <span className="font-serif italic text-[#a4514a] text-[22px]" data-testid="hero-owner-name">Catherine</span> brings calm, capable management and operations to New Zealand businesses — the systems, structure and steady hand that let owners get back to the work they do best.
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <a href="#contact" className="btn-dark">
                Start a conversation <ArrowRight size={14} />
              </a>
              <a href="tel:+642040274459" className="btn-outline" data-testid="hero-free-chat-call-button">
                <Phone size={14} /> Free chat · 020 4027 4459
              </a>
            </div>

            <div className="mt-12 flex items-center gap-3">
              <span className="w-8 h-px bg-[#c9bfae]" />
              <span className="label-caps text-[#6b625a]">5–15 hours per week · Contract basis</span>
            </div>
          </div>

          <div className="lg:col-span-5 fade-up">
            <div className="image-frame aspect-[4/5] w-full max-w-[260px] sm:max-w-[300px] mx-auto lg:mx-0 lg:ml-auto lg:max-w-[340px]">
              <img
                src={images.hero}
                alt="Catherine from Trusted Hands NZ kayak fishing on the water in New Zealand" data-testid="hero-photo"
                loading="eager"
              />
            </div>
            <div className="mt-4 max-w-[260px] sm:max-w-[300px] mx-auto lg:mx-0 lg:ml-auto lg:max-w-[340px] flex items-center justify-between">
              <span className="label-caps text-[#6b625a]">Based in Tauranga</span>
              <span className="font-serif italic text-[#a4514a] text-lg">Catherine · Trusted Hands</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
